import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AchTcComponent } from './ach-tc/ach-tc.component';
import { ACHOnFilePayment, ACHPayment } from '../../../models/invoice/ach-payment.model';
import {
  CustomerAddress,
  ManualInvoice,
  ManualInvoicePartialPaySetting,
} from '../../../models/invoice/invoice.model';
import { AlertService } from '../../../../core/alert.service';
import { CustomerManagementService } from '../../../services/customer.service';
import { InvoiceService } from '../../../services/invoice.service';
import { ACHPaymentService } from '../../../services/achpayment.service';
import {
  AccountType,
  CheckType,
  SourceComponent,
} from '../../../models/invoice/payment.model';
import { CustomerAddressFormComponent } from '../../customers/customer-address-form/customer-address-form.component';
import { ACH } from 'src/app/shared/models/invoice/ach.model';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddACH } from 'src/app/shared/models/invoice/add-ach.model';

@Component({
  selector: 'app-ach-payment',
  templateUrl: './ach-payment.component.html',
  styleUrls: ['./ach-payment.component.scss'],
})
export class ACHPaymentComponent implements OnInit {
  private getCustomerACHSubscription$: Subscription;
  
  @Input() invoiceNumber: string = '';
  @Input() customerId: number = 0;
  @Input() addressId: number = 0;
  @Input() merchantName: string = '';
  @Input() contactNumber: string = '';
  @Input() locationData: any;
  @Input() isWorkOrder: boolean;
  @Input() isPartialPayment: boolean = false;
  @Input() userId: string = '';
  @Input() isMultipleInvoices: boolean = false;
  @Input() manualInvoices: any[];
  @Input() tipAmount: number = 0;
  @Input() isSalesInvoice: boolean = false;
  @Input() customerInfo:any = {};

  busy: boolean;
  agreedToTerms: boolean = false;
  //selectedCard: any;
  //cardsOnFile: any[];
  amountToBePaid: number;
  isProcessingPayment: boolean = false;

  customerAddresses: any[];

  //cardInfo: CardInfo;
  achPaymentModel: ACHPayment = new ACHPayment();
  manualInvoice: any;
  customerAddress: CustomerAddress;

  partialPaymentSetting: ManualInvoicePartialPaySetting =
    new ManualInvoicePartialPaySetting();
  loadingPaidDetails: boolean = false;
  loadingPartialPaySettings: boolean = false;
  selectedInvoiceString: string = '';
  isCheckingAccount: boolean = true;
  customerACHDetails: ACH[] = [];
  selectedACH: ACH;
  isAddACH: boolean = false;
  isInitializing: boolean = false;
  isSaveACH: boolean = false;

  constructor(
    private modalRef: NgbActiveModal,
    private alert: AlertService,
    private customerService: CustomerManagementService,
    private invoiceService: InvoiceService,
    private achPaymentService: ACHPaymentService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.achPaymentModel.AccountType = AccountType.CHECKING;
    //this.cardsOnFile = [];
    this.manualInvoice = new ManualInvoice();
    //this.cardInfo = new CardInfo();

    if (this.isMultipleInvoices) {
      this.amountToBePaid = 0;

      this.selectedInvoiceString = '';

      this.manualInvoices.forEach((eachObj, index) => {
        if (index > 0) this.selectedInvoiceString += ',';
        this.selectedInvoiceString += eachObj.InvoiceNumber;

        if (this.isPartialPayment) {
          this.amountToBePaid += eachObj.ManualInvoice.requiredPartialPayment;
        } else {
          this.amountToBePaid +=
            eachObj.ManualInvoice.status === 'Partial'
              ? eachObj.ManualInvoice.balance - eachObj.ManualInvoice.totalPaid
              : eachObj.ManualInvoice.balance;
        }
      });
    } else {
      if (!this.isSalesInvoice) {
        this.getManualInvoice(this.invoiceNumber);
      }
    }

    //this.loadCardsOnFile(this.customerId);
    this.customerAddress = new CustomerAddress();
    this.getCustomerAddress(this.customerId);
    //this.getTermsPolicy();
    this.loadACHDetails();
  }

  getCustomerAddress(id: number) {
    this.busy = true;
    this.customerService.getCustomerAddresses(id).subscribe(
      (res: any) => {
        if (res) {
          this.customerAddresses = res;
          let addr = res.find((addr) => {
            if (this.addressId != 0) {
              return addr.Id === this.addressId;
            } else {
              return addr.IsDefault === true;
            }
          });

          if (addr) {
            this.addressId = addr.Id;
            this.customerAddress.Id = addr.Id;
            this.customerAddress.City = addr.City;
            this.customerAddress.State = addr.State;
            this.customerAddress.PostalCode = addr.ZipCode;
            this.customerAddress.StreetAddress1 = addr.StreetAddress;
            this.customerAddress.CountryCode = addr.CountryCode;
          }
        }
      },
      () => {},
      () => {
        this.busy = false;
      }
    );
  }

  addressSelected() {
    var addr = this.customerAddresses.find((addr) => {
      return addr.Id == this.addressId;
    });
    if (addr) {
      this.addressId = addr.Id;
      this.customerAddress.Id = addr.Id;
      this.customerAddress.City = addr.City;
      this.customerAddress.State = addr.State;
      this.customerAddress.PostalCode = addr.ZipCode;
      this.customerAddress.StreetAddress1 = addr.StreetAddress;
      this.customerAddress.CountryCode = addr.CountryCode;
    }
  }

  addAddress() {
    let cardDiag = this.modalService.open(CustomerAddressFormComponent, {
      size: 'lg',
    });
    cardDiag.componentInstance.customerId = this.customerId;

    cardDiag.result.then((res: CustomerAddress) => {
      if (res) {
        this.customerAddresses.push(res);
        this.addressId = res.Id;
        this.addressSelected();
      }
    });
  }

  getManualInvoice(invoiceNumber: string) {
    this.busy = true;
    this.loadingPartialPaySettings = this.isPartialPayment;

    this.invoiceService
      .getManualInvoice(invoiceNumber)
      .subscribe((res: any) => {
        if (res) {
          this.manualInvoice = res;

          if (this.isPartialPayment || this.manualInvoice.status === 'Partial')
            this.loadInvoicePartialPaySetting(invoiceNumber);
          else this.amountToBePaid = this.manualInvoice.balance.toFixed(2);
        }
        this.busy = false;
      });
  }

  loadInvoicePartialPaySetting(invoiceNumber: string) {
    this.loadingPartialPaySettings = true;
    this.amountToBePaid = 0;
    this.invoiceService
      .getPartialPaySettingByInvoiceNumber(invoiceNumber)
      .subscribe(
        (res: any) => {
          if (res) {
            this.partialPaymentSetting = res;
            if (this.manualInvoice.status === 'Partial') {
              this.loadingPaidDetails = true;
              this.invoiceService
                .getPaidManualInvoiceByInvoiceNumber(this.invoiceNumber)
                .subscribe((res: any) => {
                  this.amountToBePaid = +(
                    this.manualInvoice.balance - res.amountPaid
                  ).toFixed(2);
                  this.loadingPaidDetails = false;
                });
            } else {
              if (this.partialPaymentSetting.partialDueType === '%') {
                this.amountToBePaid = +(
                  (this.manualInvoice.balance - this.tipAmount) *
                  (this.partialPaymentSetting.partialDue / 100)
                ).toFixed(2);
              } else {
                this.amountToBePaid =
                  +this.partialPaymentSetting.partialDue.toFixed(2);
              }
              this.amountToBePaid += this.tipAmount;
            }
          }
        },
        () => {},
        () => {
          this.loadingPartialPaySettings = false;
        }
      );
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

  accountTypeChanged(event: any) {
    this.achPaymentModel.AccountType =
      event.target.value === '0' ? AccountType.CHECKING : AccountType.SAVINGS;
    this.isCheckingAccount = event.target.value === '0' ? true : false;
  }

  checkTypeChanged(event: any) {
    let chktype = event.target.value;
    if (chktype === '0') {
      this.achPaymentModel.CheckType = CheckType.PERSONAL;
    } else if (chktype === '1') {
      this.achPaymentModel.CheckType = CheckType.BUSINESS;
    } else if (chktype === '2') {
      this.achPaymentModel.CheckType = CheckType.PAYROLL;
    } else {
      this.achPaymentModel.CheckType = null;
    }
  }

  payviaACH() {
    this.achPaymentModel.Amount = this.amountToBePaid;
    this.achPaymentModel.InvoiceNumber = this.invoiceNumber;
    this.achPaymentModel.TerminalId = 'MAIN';
    this.achPaymentModel.IsPartialPayment = this.isPartialPayment;
    this.achPaymentModel.Currency = 'USD';
    this.achPaymentModel.LocationId = this.locationData.Id;

    this.achPaymentModel.CustomerId = this.customerId.toString();
    this.achPaymentModel.StreetAddress1 = this.customerAddress.StreetAddress1;
    this.achPaymentModel.City = this.customerAddress.City;
    this.achPaymentModel.State = this.customerAddress.State;
    this.achPaymentModel.PostalCode = this.customerAddress.PostalCode;
    this.achPaymentModel.SourceComponent =
      this.isWorkOrder == true
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;
    this.achPaymentModel.TransactionSource =
      this.isWorkOrder == true
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;
    this.busy = true;
    this.achPaymentService.achCharge(this.achPaymentModel).subscribe(
      (res) => {
        if (res) {
          this.modalRef.close(res);
          this.alert.alertSuccess({
            title: 'Success',
            text: 'Successfully charged ACH account!',
          });
          this.busy = false;
        }
      },
      (err) => {
        this.modalRef.close();
        this.alert.alertError({ title: 'ACH charge failed', text: err.error });
        this.busy = false;
      }
    );
    return;
  }

  processACHonFilePayment() {
    if(this.selectedACH) {
      const payload: ACHOnFilePayment = {
        customerId: this.customerId,
        locationId: this.locationData.Id,
        amount: this.amountToBePaid,
        paymentIdentifier: this.selectedACH.paymentIdentifier,
        currency: 'USD',
        terminalId: 'MAIN',
        transactionSource: this.isWorkOrder == true
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice,
        invoiceNumber: this.manualInvoice.invoiceNumber,
        isPartialPayment: this.isPartialPayment,
        sourceComponent: this.isWorkOrder == true
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice,
        userId: Number(this.userId)
      };

      this.achPaymentService
        .achOnFileCharge(payload)
          .subscribe(
            (res: any) => {
              if(res) {
                this.isProcessingPayment = false;
                this.close(true);
              }
            },
            (err) => {
              this.isProcessingPayment = false;
              this.alert.alertError(
                `Payment failed for invoice number: ${this.achPaymentModel.InvoiceNumber}`
              );
            }
          )
    }
  }

  onSaveNewACHDetail(): Promise<void> {
    const payload: AddACH = {
      customerId: this.customerId,
      locationId: this.locationData.Id,
      firstName: this.customerInfo.FirstName,
      lastName: this.customerInfo.LastName,
      accountNumber: this.achPaymentModel.AccountNumber,
      routingNumber: this.achPaymentModel.RoutingNumber,
      checkType: this.achPaymentModel.CheckType,
      accountType: this.achPaymentModel.AccountType,
      streetAddress1: this.customerAddress.StreetAddress1,
      city: this.customerAddress.City,
      state: this.customerAddress.State,
      postalCode: this.customerAddress.PostalCode,
      country: this.customerAddress.CountryCode
    };

    return new Promise((resolve, reject) => {
      this.customerService.addCustomerACHDetails(payload).subscribe(
        (res: any) => {
          resolve();
        }
      );
    })

  }

  async processPayment(): Promise<any> {
    if (!this.amountToBePaid) {
      this.alert.alertError({ text: 'Please enter an Amount.' });
      return false;
    }

    if (!this.agreedToTerms) {
      this.alert.alertError({ text: 'Please Agree to Terms and Conditions.' });
      return false;
    }

    this.isProcessingPayment = true;

    this.achPaymentModel.Amount = this.amountToBePaid;
    this.achPaymentModel.InvoiceNumber = this.manualInvoice.invoiceNumber;
    this.achPaymentModel.TerminalId = 'MAIN';
    this.achPaymentModel.IsPartialPayment = this.isPartialPayment;
    this.achPaymentModel.Currency = 'USD';
    this.achPaymentModel.LocationId = this.locationData.Id;

    this.achPaymentModel.CustomerId = this.customerId.toString();
    this.achPaymentModel.StreetAddress1 = this.customerAddress.StreetAddress1;
    this.achPaymentModel.City = this.customerAddress.City;
    this.achPaymentModel.State = this.customerAddress.State;
    this.achPaymentModel.PostalCode = this.customerAddress.PostalCode;
    this.achPaymentModel.SourceComponent =
      this.isWorkOrder == true
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;
    this.achPaymentModel.TransactionSource =
      this.isWorkOrder == true
        ? SourceComponent.WorkOrder
        : SourceComponent.ManualInvoice;

    if(this.isSaveACH) {
      await this.onSaveNewACHDetail();
    }
      
    if(!this.isAddACH) {
      this.processACHonFilePayment();
    } else {
      this.achPaymentService.achCharge(this.achPaymentModel).subscribe(
        (res: any) => {
          if (res) {
            this.isProcessingPayment = false;
            this.close(true);
          }
        },
        (err) => {
          this.isProcessingPayment = false;
          this.alert.alertError(
            `Payment failed for invoice number: ${this.achPaymentModel.InvoiceNumber}`
          );
        }
      );
    }
  }

  processMultiplePayments() {
    if (!this.amountToBePaid) {
      this.alert.alertError({ text: 'Please enter an Amount.' });
      return false;
    }

    if (!this.agreedToTerms) {
      this.alert.alertError({ text: 'Please Agree to Terms and Conditions.' });
      return false;
    }

    this.isProcessingPayment = true;
    let promises = [];

    for (var i = 0; i < this.manualInvoices.length; i++) {
      this.achPaymentModel.Amount = this.isPartialPayment
        ? this.manualInvoices[i].ManualInvoice.requiredPartialPayment
        : this.manualInvoices[i].ManualInvoice.balance -
          this.manualInvoices[i].ManualInvoice.totalPaid;
      this.achPaymentModel.InvoiceNumber =
        this.manualInvoices[i].ManualInvoice.invoiceNumber;
      this.achPaymentModel.TerminalId = 'MAIN';
      this.achPaymentModel.IsPartialPayment = this.isPartialPayment;
      this.achPaymentModel.Currency = 'USD';
      this.achPaymentModel.LocationId = this.manualInvoices[i].locationData.Id;

      this.achPaymentModel.CustomerId = this.customerId.toString();
      this.achPaymentModel.StreetAddress1 = this.customerAddress.StreetAddress1;
      this.achPaymentModel.City = this.customerAddress.City;
      this.achPaymentModel.State = this.customerAddress.State;
      this.achPaymentModel.PostalCode = this.customerAddress.PostalCode;
      this.achPaymentModel.SourceComponent =
        this.isWorkOrder == true
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice;
      this.achPaymentModel.TransactionSource =
        this.isWorkOrder == true
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice;

      promises.push(
        new Promise((resolve, reject) => {
          this.achPaymentService.achCharge(this.achPaymentModel).subscribe(
            (res: any) => {
              if (res) {
                resolve(res);
                //this.alert.alertSuccess({ title: 'Success', text: 'Successfully charged ACH account!' });
              }
            },
            (err) => {
              reject(
                `Payment failed for invoice number: ${this.achPaymentModel.InvoiceNumber}`
              );
            }
          );
        })
      );
    }

    Promise.all(promises).then((values) => {
      for (var i = 0; i < this.manualInvoices.length; i++) {
        this.manualInvoices[i].paymentResult = values[i];
      }
      this.close(this.manualInvoices);
      this.busy = false;
    });
  }

  forceMinDate(e) {
    if (e.target.value) {
      if (new Date(e.target.value) < new Date(e.target.min)) {
        e.target.value = e.target.min;
      }
    } else {
      e.target.value = e.target.min;
    }
  }

  openTermsAndCondition() {
    let achTerms = this.modalService.open(AchTcComponent, { size: 'lg' });
    achTerms.componentInstance.merchantName = this.merchantName;
    achTerms.componentInstance.contactNumber = this.contactNumber;
  }

  loadACHDetails(): void {
    this.isInitializing = true;
    this.getCustomerACHSubscription$ =
      this.customerService.getCustomerACHsById(this.customerId)
        .subscribe({
          next: (result: any) => {
            if(result) {
              this.customerACHDetails = result;
              this.getDefaultACH();
            }
            this.isInitializing = false;

          },
          error: () => {
            this.isInitializing = false;
          }
        })
  }

  getDefaultACH(): void {
    if (this.customerACHDetails.length && !this.selectedACH) {
      const card = this.customerACHDetails.find((e) => e.isDefault);
      this.onSelectACH(card?.paymentIdentifier || this.customerACHDetails[0].paymentIdentifier);
    }
  }

  onSelectACH(paymentIdentifier: string): void {
    const ach = this.customerACHDetails.find((e) => e.paymentIdentifier === paymentIdentifier);

    if (ach) {
      this.selectedACH = ach;
    }
  }

  onAddACH(): void {
    this.isAddACH = !this.isAddACH;
  }
}
